import React from "react";
import { MathUtils } from "utils";
import SubscriptionTotals from "pages/SubscriptionProducts/SubscriptionTotals";

const EstimatedRecurringAmount = ({ quote, cart, shouldNotDisplayPriceChanges, masterPricingSchedule = null }) => {
    const { grossTotal, subtotal, totalDiscount, totalTax, totalFee } = cart
        .filter((item) => {
            const productDetails = quote.quote_summary.find(
                (quoteItem) =>
                    quoteItem.product_id === item.id &&
                    quoteItem.product_variation_id === item.variation_id
            );
            return !Boolean(item.removed) && productDetails?.price_data?.model?.includes("recurring");
        })
        .reduce(
            (a, item) => {
                const productDetails = quote.quote_summary.find(
                    (quoteItem) =>
                        quoteItem.product_id === item.id &&
                        quoteItem.product_variation_id === item.variation_id
                );
                const price_data = Object.keys(productDetails.price_data).length ? productDetails.price_data : null;
                const price = (() => {
                    if (productDetails.dyl_product_name?.includes("_balance")) {
                        return item.amount || 0;
                    }
                    if (!price_data || shouldNotDisplayPriceChanges) {
                        return productDetails.item_price || 0;
                    }
                    const isOneTime =
                        !price_data?.model?.includes(
                            "recurring"
                        );
                    const pricingModel = price_data.model;
                    if (isOneTime) {
                        if (!pricingModel.includes("volume")) {
                            return pricingModel === "usage"
                                ? price_data.price.price
                                : price_data.price;
                        }
                        return (
                            price_data.price.find(
                                (range) =>
                                    item.quantity >= range.start &&
                                    item.quantity <=
                                    (range.end || Number.POSITIVE_INFINITY)
                            )?.price || 0
                        );
                    }
                    const price_schedule = price_data.price[masterPricingSchedule || item.pricing_schedule];
                    if (!pricingModel.includes("volume")) {
                        return (
                            productDetails?.prorate_amount || price_schedule?.price || 0
                        );
                    }
                    const frequency = price_schedule?.volumes || [];
                    const volumeTier = frequency.find(
                        (range) => item.quantity >= range.start &&
                            item.quantity <=
                            (range.end || Number.POSITIVE_INFINITY)
                    );
                    return (
                        productDetails?.prorate_amount || volumeTier?.price || 0
                    );
                })();

                const {
                    totalTax,
                    totalFee,
                    grossTotal,
                    subtotal,
                    discountAmount,
                } = MathUtils.calculateItemTotals({
                    price,
                    additional_price:
                        productDetails.product_additional_price || 0,
                    quantity: item.quantity,
                    discount: item.discount || 0,
                    addons: productDetails.addon
                        ?.filter(
                            (addon) =>
                                item.addons.includes(addon.id) && !addon.unlinked
                        )
                        .map((addon) => ({
                            price: addon.current_price || 0,
                        })) || [],
                    taxes: productDetails.tax?.map((tax) => ({
                        amount: tax.current_amount || tax.amount,
                        percent: tax.tax_fee_percent,
                    })) || [],
                    fees: productDetails.fee?.map((fee) => ({
                        amount: fee.current_amount || fee.amount,
                        percent: fee.tax_fee_percent,
                    })) || [],
                });

                return {
                    grossTotal: a.grossTotal + grossTotal,
                    totalDiscount: a.totalDiscount + discountAmount,
                    totalTax: a.totalTax + totalTax,
                    totalFee: a.totalFee + totalFee,
                    subtotal: a.subtotal + subtotal,
                };
            },
            {
                grossTotal: 0,
                totalDiscount: 0,
                totalTax: 0,
                totalFee: 0,
                subtotal: 0,
            }
        );

    return (
        <SubscriptionTotals
            header="Estimated Recurring Amount"
            subtotal={subtotal}
            totalDiscount={totalDiscount}
            totalFee={totalFee}
            totalTax={totalTax}
            total={grossTotal}
        />
    );
};

export default EstimatedRecurringAmount;
